<template>
  <div
    class="message-content"
    :class="{
      'client-side': user.isCustomer,
      'agent-side': !user.isCustomer,
      rtl: dir == 'rtl',
    }"
    v-if="message.files"
  >
    <div class="avatar" v-if="!user.isCustomer">
      <el-avatar
        :size="32"
        :src="formateAvatar(user.avatar)"
        slot="reference"
        alt="Avatar"
      ></el-avatar>
    </div>
    <div class="content">
      <div class="name" v-if="!user.isCustomer">
        {{ user.nickname || user.username || user.firstName + user.lastName }}
      </div>
      <div class="image" v-loading="loading">
        <div
          class="loading"
          v-loading="true"
          element-loading-background="rgba(0, 0, 0, 0.1)"
          v-if="loading"
        ></div>
        <el-image
          fit="contain"
          :src="url"
          v-for="(url, idx) in images"
          :key="idx"
          :preview-src-list="images"
        >
        </el-image>
      </div>
      <div class="files">
        <div class="file" v-for="(f, idx) in msg_other_file" :key="idx">
          <div class="file-icon">
            <i class="bx bx-file"></i>
          </div>
          <div class="file-infos">
            <div class="file-name">{{ f.name }}</div>
            <div class="file-size">{{ f.size }}</div>
          </div>
          <div
            class="file-dowload"
            tabindex="0"
            aria-label="Download file"
            @click="getDownloadLink(f.url)"
            @keyup.enter="getDownloadLink(f.url)"
          >
            <i class="bx bx-download"></i>
          </div>
        </div>
      </div>

      <div class="time">{{ message.createAt }}</div>
    </div>
  </div>
</template>

<script>
import { Customer } from "@/api/customer.js";
export default {
  name: "chat-message-image-and-file",
  props: {
    message: {
      type: Object,
    },
    isMe: {
      type: Boolean,
    },
    user: {
      type: Object,
    },
    customer: {
      type: Object, // for download params
    },
  },
  data() {
    return {
      loading: false,
      images: [],
    };
  },
  mounted() {
    this.images = this.formateImages(this.msg_image_file);
  },
  methods: {
    formateAvatar(url) {
      if (url) {
        return process.env.VUE_APP_BASEURL + url;
      } else {
        return require("@/assets/images/avatar-3.jpg");
      }
    },
    formateImages(files) {
      // 一般 url 模式
      let result = [];
      let urls = files.map((file) => {
        return file.url;
      });
      urls.forEach((url) => {
        let imgUrl = process.env.VUE_APP_BASEURL + url;
        result.push(imgUrl);
      });
      return result;
    },
    async getBlobImage(url) {
      let params = {
        clientChatRoomId: this.roomId,
        customerId: this.customer.id,
        token: this.customer.token,
        filePath: url,
      };
      let blobUrl;
      this.loading = true;
      await Customer.DownloadUploadFile(params, {
        responseType: "blob",
      }).then((res) => {
        var blob = new Blob([res.data], { type: "image/jpeg" });
        blobUrl = window.URL.createObjectURL(blob);
      });
      this.loading = false;
      return blobUrl;
    },
    getDownloadLink(path) {
      let filePath = path.substring(1);
      let params = {
        clientChatRoomId: this.roomId,
        customerId: this.customer.id,
        token: this.customer.token,
        filePath: filePath,
      };

      Customer.DownloadUploadFile(params, {
        responseType: "blob",
      }).then((res) => {
        const { headers } = res;
        const fileName = decodeURI(headers["content-disposition"])
          .split(" ")
          .find((el) => {
            return el.includes("filename=");
          })
          .replace("filename=", "");

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(res.data, fileName);
        } else {
          var blob = new Blob([res.data], { type: "octet-stream" }),
            url = window.URL.createObjectURL(blob);
          this.createDownloadLink(url, fileName);
        }
      });
    },
    createDownloadLink(url, fileName) {
      let downloadLink = document.createElement("a");
      downloadLink.target = "_blank";
      downloadLink.rel = "noreferrer noopener";
      downloadLink.download = fileName;
      downloadLink.style.display = "none";
      downloadLink.href = url;
      downloadLink.click();
    },
  },
  computed: {
    dir() {
      return this.$store.state.global.dir;
    },
    msg_image_file() {
      // let type = [".jpg", ".jpeg", ".png", ".bmp"]; // heic 網頁無法顯示
      let files = this.message.files;
      if (files) {
        let images = files.filter((f) => {
          return (
            f.type == ".jpg" ||
            f.type == ".jpeg" ||
            f.type == ".png" ||
            f.type == ".bmp"
          );
        });
        return images;
      } else {
        return [];
      }
    },
    msg_other_file() {
      let files = this.message.files;
      if (files) {
        let others = files.filter((f) => {
          return (
            f.type !== ".jpg" &&
            f.type !== ".jpeg" &&
            f.type !== ".png" &&
            f.type !== ".bmp"
          );
        });
        return others;
      } else {
        return [];
      }
    },
    roomId() {
      return this.$store.state.global.lastClientChatRoomInfo?.id;
    },
  },
};
</script>

<style lang="scss">
@import "chat.scss";
</style>
